import { Component, OnInit, QueryList, ViewChildren } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { DateView } from "@danielmoncada/angular-datetime-picker";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { select, Store } from "@ngrx/store";
import { Observable, skip, take, takeUntil } from "rxjs";
import { BaseComponent } from "src/app/base.component";
import {
  NgbdSortableHeader,
  SortEvent,
} from "src/app/shared/directive/sortable.directive";
import { FilterListAdvertisingCompaign } from "src/app/shared/models/advertising-campaigns/filter-list-advertising-compaign.interface";
import { ResultFilterAdvertisingCompaign } from "src/app/shared/models/advertising-campaigns/result-filter-advertising-compaign.interface";
import {
  CampaignStatusEnum,
  CampaignStatusEnumMapping,
} from "src/app/shared/enum/campaign-status";
import { SuccessDto } from "src/app/shared/models/success-dto";
import { IColumn } from "src/app/shared/models/table/column.interface";
import { BadgeService } from "src/app/shared/services/badge.service";
import {
  adCampaignSelector,
  loadingAdvertisingCampaignTableSelector,
  resultAddSynthesisReportSelector,
  resultFilterAdvertisingCompaignSelector,
  successUploadFileSelector,
  updateAdCampaignDetailsSelector,
} from "src/app/store/advertisingCampaign/advertiserCampaign.selectors";
import {
  advertisingCompaignResult,
  invokeAdvertisingCompaignFilter,
  resultAddSynthesisReport,
  resultSuccessAd,
  resultUploadJustificationFile,
  resultUploadResponsesFile,
} from "src/app/store/advertisingCampaign/advertisingCampaign.actions";
import { initialState } from "src/app/store/advertisingCampaign/advertisingCampaign.reducers";
import { AppStateInterface } from "src/app/store/appState.interface";
import {
  ObjectiveTypeEnum,
  ObjectiveTypeEnumMapping,
} from "src/app/shared/enum/objectives";
import { UploadFilesComponent } from "src/app/shared/components/upload-files/upload-files.component";
import {
  ActionInterface,
  ActionReturned,
  OptionActionEnum,
  adminCampaignActions,
} from "src/app/shared/data/actions-data";
import { DetailsAdComponent } from "src/app/shared/components/details-modal/details-ad/details-ad.component";
import { VideoAdComponent } from "src/app/shared/components/video-ad/video-ad.component";
import { environment } from "src/environments/environment";
import { RoleEnum } from "src/app/shared/models/user/role.interface";
import { UpdateCampaignStatusComponent } from "./update-campaign-status/update-campaign-status.component";
import {
  advertisingCampaignsFilter,
  FilterInterface,
} from "src/app/shared/data/filter-data";
import { UpdateCampaignComponent } from "./update-campaign/update-campaign.component";
import { AdvertisingCampaignInterface } from "src/app/shared/models/advertising-campaigns/advertising-campaign.interface";
import { ToastrService } from "ngx-toastr";
import { TranslateService } from "@ngx-translate/core";
import { invokeApiDistroyed } from "src/app/store/apiState.interface";
import {
  invokeDownloadFile,
  resultDownloadFile,
} from "src/app/store/file/file.actions";
import { downloadedFileSelector } from "src/app/store/file/file.selectors";
import { DeleteComponent } from "src/app/shared/components/drop-zone-options/modal/delete/delete.component";
import { ExtensionService } from "src/app/shared/services/extension/extension.service";
import { Router } from "@angular/router";
import { UserHistoryActionsEnum } from "src/app/shared/enum/userHistoryActions";
import { UserHistoryServicesEnum } from "src/app/shared/enum/userHistoryService";
import { SaveUserHistoryService } from "src/app/shared/services/history/saveHistory";
import { getAdHavePromotionCode } from "src/app/store/promotion-code/promotion-code.actions";
import { calculateTotalLPCostByCampanyNames } from "src/app/store/locationPartner/location-partner.action";
import { catchForbiddenError } from "src/app/store/user/user.actions";
import { catchForbiddenErrorSelector } from "src/app/store/user/user.selectors";
import { ResultSynthesisEstimate } from "src/app/shared/models/iberis/commande/resultSynthesisEstimate";
import { resultSynthesisEstimateSelector } from "src/app/store/commande/commande.selectors";
import { Data } from "src/app/shared/models/iberis/commande/data";
import { CommonParamsIberis } from "src/app/shared/models/iberis/paramsForGetAll";
import { CancelEstimate } from "src/app/shared/services/iberis/cancelEstimate";
import { resultSynthesisEstimate } from "src/app/store/commande/commande.actions";
import { JwtService } from "src/app/shared/services/jwt.service";
import { Authorities } from "src/app/shared/enum/authorities";
import { RefreshButtonState } from "src/app/shared/enum/refreshButtonState";
import { FiltersService } from "src/app/shared/services/filters.service";
import { FilterParams } from "src/app/shared/models/filterParams";
import { Constants } from "src/app/shared/data/constants";
@Component({
  selector: "app-ads-compaigns",
  templateUrl: "./ads-compaigns.component.html",
})
export class AdsCompaignsComponent extends BaseComponent implements OnInit {
  @ViewChildren(NgbdSortableHeader) headers!: QueryList<NgbdSortableHeader>;
  public years = DateView.MULTI_YEARS;
  columns: IColumn[] = [
    {
      key: "title",
      label: "admin.campaigns.pipeline.campaignName",
      sorter: true,
      width: 20,
    },
    {
      key: "firstName",
      label: "admin.campaigns.pipeline.advertiser",
      sorter: true,
      width: 15,
    },
    {
      key: "objective",
      label: "admin.campaigns.pipeline.objective",
      sorter: true,
      width: 15,
    },
    {
      key: "locations",
      label: "admin.campaigns.pipeline.locations",
      sorter: false,
      width: 40,
    },
    {
      key: "startingDate",
      label: "admin.campaigns.pipeline.startDate",
      sorter: true,
      width: 15,
    },
    {
      key: "endingDate",
      label: "admin.campaigns.pipeline.endDate",
      sorter: true,
      width: 15,
    },
  ];
  date = [null, null];
  pageSize: number = Constants.defaultTableSize;
  pageNumber: number = 1;
  advertisingCampaignFilter: FilterListAdvertisingCompaign = {
    ...initialState.filter,
    pager: {
      pageSize: this.pageSize,
      pageNumber: this.pageNumber,
    },
  };
  resultFilterAdvertisingCompaign$: Observable<ResultFilterAdvertisingCompaign | null>;
  resultAdvertisingCompainFilter: ResultFilterAdvertisingCompaign;
  formFilter: FormGroup;
  form: FormGroup;
  validate: string;
  submitted: boolean;
  adCampaign$: Observable<SuccessDto | null>;
  resultUpdateAdCampaign: SuccessDto | null;
  titleCampaign: string;
  waiting: boolean;
  campaignObjective = ObjectiveTypeEnumMapping;
  count: number;
  advertisingCampaign: AdvertisingCampaignInterface[] = [];
  campaignStatus = CampaignStatusEnum;
  loading$: Observable<boolean | null>;

  companyName: string[] = [];

  filterAds: FilterInterface = advertisingCampaignsFilter;

  addSynthesisReport$: Observable<SuccessDto | null>;
  resultAddSynthesisReport: SuccessDto | null;
  successMessage: string;
  successMessage$: Observable<SuccessDto | null>;

  downloadFile$: Observable<any>;
  resultDownloadFile: any;
  blob: Blob;
  adTitle: string;
  successUploadJustificatif$: Observable<SuccessDto | null>;
  cachedAt: Date | null;
  catchForbiddenError$: Observable<boolean | null>;
  forbidden: boolean | null = false;
  loading: boolean | null;
  isConfirmAction: boolean;

  resultSynthesisEstimate$: Observable<ResultSynthesisEstimate | null>;
  syntesisEstimate: Data;

  params: CommonParamsIberis = {
    lang: "fr",
    companyId: environment.IBERIS.IBERIS_COMPANY_ID,
  };
  currentAd: AdvertisingCampaignInterface;
  currentAction: ActionReturned;

  deleteUpdateModal: NgbModalRef;
  fetchingCampaignState: RefreshButtonState = RefreshButtonState.IDLE;

  filters: FilterParams | null = null;
  constructor(
    private store: Store<AppStateInterface>,
    private fb: FormBuilder,
    public badgeService: BadgeService,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private translate: TranslateService,
    private extensionService: ExtensionService,
    private router: Router,
    private saveHistory: SaveUserHistoryService,
    private jwtService: JwtService,
    private deleteEstimateService: CancelEstimate,
    private filtersService: FiltersService
  ) {
    super(store);
    this.catchForbiddenError$ = this.store
      .pipe(select(catchForbiddenErrorSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.resultFilterAdvertisingCompaign$ = this.store
      .pipe(select(resultFilterAdvertisingCompaignSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.adCampaign$ = this.store
      .pipe(select(adCampaignSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.loading$ = this.store
      .pipe(select(loadingAdvertisingCampaignTableSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.addSynthesisReport$ = this.store
      .pipe(select(resultAddSynthesisReportSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.successMessage$ = this.store
      .pipe(select(updateAdCampaignDetailsSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.downloadFile$ = this.store
      .pipe(select(downloadedFileSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.successUploadJustificatif$ = this.store
      .pipe(select(successUploadFileSelector))
      .pipe(takeUntil(this.ngDestroyed$));

    this.resultSynthesisEstimate$ = this.store
      .pipe(select(resultSynthesisEstimateSelector))
      .pipe(takeUntil(this.ngDestroyed$));

    this.formFilter = this.fb.group({
      title: [""],
      date: [[null, null]],
    });
    this.form = this.fb.group({
      title: [""],
      objectiveName: [""],
      uploadVideo: [""],
      redirectionLink: [""],
    });

    const authorities = this.jwtService.getPermissions(jwtService.getToken());
    if (authorities) {
      this.forbidden = !authorities.includes(Authorities.ADC_GETALL.toString());
    }

    this.extractFilters();
  }

  extractFilters() {
    this.filters = this.filtersService.decodeUri();
    if (this.filters) {
      this.advertisingCampaignFilter.status =
        this.findOption(this.filters.statuses) ?? [];
    }
    this.pageNumber = this.filtersService.extractValueFromUrl(
      this.filters,
      "page",
      this.pageNumber
    );
    this.pageSize = this.filtersService.extractValueFromUrl(
      this.filters,
      "size",
      this.pageSize
    );

    this.filtersService.patchFormValue(
      this.filters,
      ["title", "date"],
      this.formFilter
    );

    this.advertisingCampaignFilter = {
      ...this.advertisingCampaignFilter,
      title: this.formFilter.get("title")?.value,
      startingDate: this.formFilter.get("date")?.value[0],
      endingDate: this.formFilter.get("date")?.value[1],
      pager: {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      },
    };
  }
  ngOnInit(): void {
    this.formFilter.valueChanges.subscribe((value) => {
      this.pageNumber = 1;
      this.pageSize = Constants.defaultTableSize;
      this.advertisingCampaignFilter = {
        ...this.advertisingCampaignFilter,
        title: value.title,
        startingDate: value.date[0] ?? null,
        endingDate: value.date[1] ?? null,
        pager: {
          pageNumber: this.pageNumber,
          pageSize: this.advertisingCampaignFilter.pager.pageSize,
        },
      };
      this.refreshCampaigns(false);
    });
    this.catchForbiddenError$.subscribe((result) => {
      if (result) {
        this.store.dispatch(catchForbiddenError({ forbiddenError: null }));
      }
    });
    this.addSynthesisReport$.subscribe((created: SuccessDto | null) => {
      if (created !== null) {
        this.toastr.success(
          this.translate.instant("response.success." + created.message),
          this.translate.instant("response.successTitle")
        );
        this.store.dispatch(resultAddSynthesisReport({ successMessage: null }));
        this.refreshCampaigns(false);
      }
    });
    this.filterAds.name.map(
      (e) =>
        (e.data = Object.keys(CampaignStatusEnum)
          .filter(
            (key) =>
              isNaN(Number(key)) &&
              key !== "CANCELED_BY_FRANCHISE" &&
              key !== "CANCELED_BY_ADMIN"
          )
          .map(
            (key: string | any) =>
              CampaignStatusEnumMapping[key as keyof typeof CampaignStatusEnum]
          ))
    );
    this.loading$.subscribe((data) => {
      this.loading = data;
    });
    this.store.dispatch(
      advertisingCompaignResult({ listAdvertisingCompaign: null })
    );
    this.resultFilterAdvertisingCompaign$.subscribe((result) => {
      if (result) {
        this.resultAdvertisingCompainFilter = result;
        this.count = this.resultAdvertisingCompainFilter.count;
        if (this.resultAdvertisingCompainFilter.advertisingCampaigns) {
          this.companyName = [];
          this.advertisingCampaign =
            this.resultAdvertisingCompainFilter.advertisingCampaigns;
          this.advertisingCampaign?.map((e) => {
            this.companyName = [...this.companyName, e.publisherCompanyName];
          });
          this.cachedAt = result.cachedAt;
        }
      } else {
        this.refreshCampaigns(false);
        this.saveHistory.saveUserHistory(
          UserHistoryActionsEnum.GET,
          UserHistoryServicesEnum.LIST_CAMPAIGNS
        );
      }
    });

    this.adCampaign$.subscribe((result: SuccessDto | null) => {
      if (result !== null) {
        this.resultUpdateAdCampaign = result;
      }
    });
    this.successMessage$.subscribe((data) => {
      if (data) {
        this.successMessage = data.message;
        this.store.dispatch(resultSuccessAd({ successMessage: null }));
        if (this.successMessage !== "") {
          this.modalService.dismissAll();
        }
      }
    });
    this.successUploadJustificatif$.subscribe((success: SuccessDto | null) => {
      if (success !== null) {
        this.store.dispatch(
          resultUploadJustificationFile({ successUpload: null })
        );
        this.store.dispatch(resultUploadResponsesFile({ successUpload: null }));
        this.toastr.success(
          this.translate.instant("response.success." + success.message),
          this.translate.instant("response.successTitle")
        );
        if (this.successMessage !== "") {
          this.modalService.dismissAll();
          this.refreshCampaigns(true);
        }
      }
    });

    this.downloadFile$.subscribe((result) => {
      if (result) {
        this.blob = result.body as Blob;
        const pdf = URL.createObjectURL(this.blob);
        const downloadLink = document.createElement("a");
        downloadLink.href = pdf;
        downloadLink.download = `${this.translate.instant(
          "campaignDetails.justificationFile"
        )}-${this.adTitle}.${this.extensionService.getExtension(result.url)}`;
        downloadLink.click();
        URL.revokeObjectURL(pdf);
        this.store.dispatch(resultDownloadFile({ downloadedFile: null }));
      }
    });

    this.resultSynthesisEstimate$.subscribe(
      (result: ResultSynthesisEstimate | null) => {
        if (result && result?.status.code == 200) {
          this.syntesisEstimate = result.data.estimate;
          this.deleteEstimateService.cancelEstimate(
            result.data.estimate,
            this.currentAd,
            this.currentAction.option.type
          );
        } else if (result?.status.code == 404) {
          this.toastr.error(
            this.translate.instant("response.error.undefined"),
            this.translate.instant("response.errorTitle")
          );
          this.store.dispatch(
            resultSynthesisEstimate({ resultSynthesisEstimate: null })
          );
          this.deleteUpdateModal.close();
        }
      }
    );
  }

  changePage(event: number) {
    this.pageNumber = event;
    this.advertisingCampaignFilter = {
      ...this.advertisingCampaignFilter,
      pager: {
        pageNumber: this.pageNumber,
        pageSize: this.advertisingCampaignFilter.pager.pageSize,
      },
    };
    this.refreshCampaigns(false);
  }

  itemsPerPageChange(pageSize: number) {
    this.pageSize = pageSize;
    this.pageNumber = 1;
    this.advertisingCampaignFilter = {
      ...this.advertisingCampaignFilter,
      pager: {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      },
    };
    this.refreshCampaigns(false);
  }

  removeFilter() {
    this.formFilter.reset({
      title: "",
      date: [null, null],
    });
    this.store.dispatch(
      invokeAdvertisingCompaignFilter({
        filter: {
          ...initialState.filter,
          roleNames: [RoleEnum.ROLE_ADVERTISER],
          pager: {
            pageSize: this.pageSize,
            pageNumber: this.pageNumber,
          },
        },
        refreshCache: false,
      })
    );
  }
  onSort({ column, direction }: SortEvent) {
    this.headers.forEach((header) => {
      if (column !== header.sortable) {
        header.direction = "";
      }
    });
    var col: string | null = column;
    var sort = null;
    switch (direction) {
      case "asc":
        sort = true;
        break;
      case "desc":
        sort = false;
        break;
      default:
        sort = true;
        col = null;
    }
    this.advertisingCampaignFilter = {
      ...this.advertisingCampaignFilter,
      sortName: col,
      isAscending: sort,
    };
    this.refreshCampaigns(false);
  }

  findOption(options: string[] | null) {
    let listFounds: any[] = [];
    options?.map((option) => {
      listFounds.push(
        Object.keys(CampaignStatusEnumMapping).find(
          (key) =>
            CampaignStatusEnumMapping[key as CampaignStatusEnum] === option
        )
      );
    });
    return listFounds;
  }
  saveOption(options: string[] | null) {
    this.pageNumber = 1;
    let listFounds = this.findOption(options);
    this.advertisingCampaignFilter = {
      ...this.advertisingCampaignFilter,
      status: listFounds,
      pager: {
        ...this.advertisingCampaignFilter.pager,
        pageNumber: this.pageNumber,
      },
    };
    this.refreshCampaigns(false);
  }
  saveAction(action: ActionReturned, ad: AdvertisingCampaignInterface) {
    this.currentAd = ad;
    this.currentAction = action;
    switch (action.option.type) {
      case OptionActionEnum.ADVERTISER_CAMPAIGNS_STATISTICS: {
        this.router.navigate([
          "/",
          "dashboard",
          "admin",
          "campaigns",
          "pipeline",
          "statistics",
          ad.advertisingCampaignHashedId,
        ]);
        this.saveHistory.saveUserHistory(
          UserHistoryActionsEnum.GET,
          UserHistoryServicesEnum.ADVERTISER_CAMPAIGNS_STATISTICS
        );
        break;
      }
      case OptionActionEnum.CAMPAIGN_DETAILS: {
        const modal = this.modalService.open(DetailsAdComponent, {
          centered: true,
          size: "lg",
        });
        modal.componentInstance.detailsAd = ad;
        this.saveHistory.saveUserHistory(
          UserHistoryActionsEnum.GET,
          UserHistoryServicesEnum.CAMPAIGN_DETAILS
        );
        this.store.dispatch(getAdHavePromotionCode({ result: null }));
        this.store.dispatch(
          calculateTotalLPCostByCampanyNames({ totalPriceWithDiscount: null })
        );
        break;
      }
      case OptionActionEnum.ADMIN_CAMPAIGN_ADVERTISER_UPDATE: {
        const modal = this.modalService.open(UpdateCampaignComponent, {
          centered: true,
          size: "lg",
        });
        modal.componentInstance.ad = ad;
        modal.componentInstance.confirmAction.subscribe(
          (value: boolean) => (this.isConfirmAction = value)
        );
        break;
      }
      case OptionActionEnum.ADMIN_CAMPAIGN_UPDATE_STATUS: {
        this.deleteUpdateModal = this.modalService.open(
          UpdateCampaignStatusComponent,
          {
            centered: true,
          }
        );
        this.deleteUpdateModal.componentInstance.detailsAd = ad;
        this.deleteUpdateModal.componentInstance.publisherRole =
          RoleEnum.ROLE_ADVERTISER;
        break;
      }
      case OptionActionEnum.CAMPAIGN_DELETE: {
        this.deleteUpdateModal = this.modalService.open(DeleteComponent, {
          centered: true,
        });
        this.deleteUpdateModal.componentInstance.name = "pop-up.campaign.title";
        this.deleteUpdateModal.componentInstance.reference = ad.title;
        this.deleteUpdateModal.componentInstance.CampaignHashedId =
          ad.advertisingCampaignHashedId;
        this.deleteUpdateModal.componentInstance.estimateId = ad.estimateId;
        this.deleteUpdateModal.componentInstance.title = action.option.name;
        this.deleteUpdateModal.componentInstance.currentAd = ad;
        this.deleteUpdateModal.componentInstance.type =
          OptionActionEnum.CAMPAIGN_DELETE;
        this.deleteUpdateModal.componentInstance.publisherRole =
          RoleEnum.ROLE_ADVERTISER;
        this.deleteUpdateModal.componentInstance.confirmAction.subscribe(
          (value: boolean) => (this.isConfirmAction = value)
        );
        break;
      }
      case OptionActionEnum.ADMIN_CAMPAIGN_SHOW_VIDEO: {
        const modal = this.modalService.open(VideoAdComponent, {
          centered: true,
          size: "lg",
        });
        modal.componentInstance.videoLink =
          environment.CDN_RELEAD + ad.videoLink;
        modal.componentInstance.closeTheModal.subscribe((value: boolean) =>
          modal.close()
        );
        this.saveHistory.saveUserHistory(
          UserHistoryActionsEnum.GET,
          UserHistoryServicesEnum.ADMIN_CAMPAIGN_ADVERTISER_SHOW_VIDEO
        );
        break;
      }
      case OptionActionEnum.ADMIN_CAMPAIGN_ADD_SYNTHESIS_REPORT: {
        const modal = this.modalService.open(UploadFilesComponent, {
          centered: true,
          size: "lg",
        });
        modal.componentInstance.campaignHashedId =
          ad.advertisingCampaignHashedId;
        modal.componentInstance.modalTitle = action.option.name;
        modal.componentInstance.action =
          OptionActionEnum.ADMIN_CAMPAIGN_ADD_SYNTHESIS_REPORT;
        modal.componentInstance.savedFile = ad.synthesisReport;
        modal.componentInstance.accept =
          "application/pdf, .csv, image/*, .pptx";
        modal.componentInstance.closeTheModal.subscribe((value: boolean) =>
          modal.close()
        );
        break;
      }
      case OptionActionEnum.CAMPAIGN_ADD_JUSTIFICATION_FILE: {
        const modal = this.modalService.open(UploadFilesComponent, {
          centered: true,
          size: "lg",
        });
        modal.componentInstance.campaignHashedId =
          ad.advertisingCampaignHashedId;
        modal.componentInstance.modalTitle = action.option.name;
        modal.componentInstance.action =
          OptionActionEnum.CAMPAIGN_ADD_JUSTIFICATION_FILE;
        modal.componentInstance.savedFile = ad.justificationFile;
        modal.componentInstance.accept = "application/pdf, image/*";
        modal.componentInstance.closeTheModal.subscribe((value: boolean) =>
          modal.close()
        );
        break;
      }
      case OptionActionEnum.CAMPAIGN_DOWNLOAD_JUSTIFICATION_FILE: {
        this.adTitle = ad.title;
        this.store.dispatch(
          invokeDownloadFile({ filename: ad.justificationFile })
        );
        this.saveHistory.saveUserHistory(
          UserHistoryActionsEnum.DOWNLOAD,
          UserHistoryServicesEnum.CAMPAIGN_DOWNLOAD_JUSTIFICATION_FILE
        );
        break;
      }
      case OptionActionEnum.RESPONSES_UPLOAD: {
        const modal = this.modalService.open(UploadFilesComponent, {
          centered: true,
          size: "lg",
        });
        modal.componentInstance.campaignHashedId =
          ad.advertisingCampaignHashedId;
        modal.componentInstance.modalTitle = action.option.name;
        modal.componentInstance.action = OptionActionEnum.RESPONSES_UPLOAD;
        modal.componentInstance.savedFile = ad.responsesFile;
        modal.componentInstance.accept =
          "application/pdf, .csv, image/*, .pptx";
        modal.componentInstance.closeTheModal.subscribe((value: boolean) =>
          modal.close()
        );
        break;
      }
    }
  }
  getOptions(ad: AdvertisingCampaignInterface): ActionInterface[] {
    var actions: ActionInterface[] = adminCampaignActions;
    if (ad.status !== CampaignStatusEnum.FINISHED)
      actions = actions.filter(
        (option) =>
          option.type !== OptionActionEnum.ADMIN_CAMPAIGN_ADD_SYNTHESIS_REPORT
      );
    if (ad.status == CampaignStatusEnum.FINISHED)
      actions = actions.filter(
        (option) =>
          option.type !== OptionActionEnum.ADMIN_CAMPAIGN_ADVERTISER_UPDATE &&
          option.type !== OptionActionEnum.ADMIN_CAMPAIGN_UPDATE_STATUS
      );
    if (ad.status == CampaignStatusEnum.CANCELED)
      actions = actions.filter(
        (option) =>
          option.type !== OptionActionEnum.CAMPAIGN_ADD_JUSTIFICATION_FILE &&
          option.type !== OptionActionEnum.ADMIN_CAMPAIGN_ADVERTISER_UPDATE &&
          option.type !== OptionActionEnum.ADMIN_CAMPAIGN_UPDATE_STATUS
      );
    if (ad.justificationFile == null)
      actions = actions.filter(
        (option) =>
          option.type !== OptionActionEnum.CAMPAIGN_DOWNLOAD_JUSTIFICATION_FILE
      );

    // Only show upload responses file option when the campaign's objective is Lead Generation
    // And the campaign is running or is finished
    if (
      (ad.status !== CampaignStatusEnum.ONGOING &&
        ad.status !== CampaignStatusEnum.FINISHED) ||
      ad.objectiveName !== ObjectiveTypeEnum.GENERATION_DE_PROSPECTS
    ) {
      actions = actions.filter(
        (option) => option.type !== OptionActionEnum.RESPONSES_UPLOAD
      );
    }

    return actions;
  }

  refreshCampaigns(refreshCache: boolean) {
    if (refreshCache) {
      this.fetchingCampaignState = RefreshButtonState.LOADING;

      this.resultFilterAdvertisingCompaign$
        .pipe(skip(1), take(1))
        .subscribe((result) => {
          if (result) {
            this.fetchingCampaignState = RefreshButtonState.SUCCESS;
            setTimeout(
              () => (this.fetchingCampaignState = RefreshButtonState.IDLE),
              2500
            );
          } else {
            this.fetchingCampaignState = RefreshButtonState.LOADING;
          }
        });
    }
    this.store.dispatch(invokeApiDistroyed());
    this.store.dispatch(
      invokeAdvertisingCompaignFilter({
        filter: {
          ...this.advertisingCampaignFilter,
          roleNames: [RoleEnum.ROLE_ADVERTISER],
        },
        refreshCache: refreshCache,
      })
    );
    this.resultFilterAdvertisingCompaign$
      .pipe(skip(1), take(1))
      .subscribe((result) => {
        this.fetchingCampaignState = RefreshButtonState.SUCCESS;
        setTimeout(
          () => (this.fetchingCampaignState = RefreshButtonState.IDLE),
          2500
        );
      });
  }

  createAdvertisingCampaign() {
    this.router.navigate([
      "/",
      "dashboard",
      "admin",
      "advertising-campaigns",
      "create-ad",
    ]);
  }
}
